export default __webpack_public_path__ + "static/media/303.769b9d8d.jpg";